<template>
	<Modal
		v-if="showModal"
		id="import-file-modal"
		class="legal-modal"
		:class="modalWidth"
		ref="importFileModal"
		:show="showModal"
		:waiting="waiting"
		@close="handleModalClose"
		:modalTitle="modalTitle"
		:actionBtnName="actionBtnName"
		:altButtons="altButtons"
		:showBackCaret="showBackCaret"
		:downloadButtons="downloadButtons"
		:showQuickAction="showQuickAction"
		@back="handleBackClick"
		@clicked="handleClick"
		@handleCalyxReportDownload="handleCalyxReportDownload"
		@handleJobAidDownload="handleJobAidDownload"
		@handleExcelDownload="handleExcelDownload"
	>
		<MultipleContactsImport
			slot="modalContent"
			ref="contactimport"
			@stateChange="handleContactImportState($event)"
			@waiting="handleWaiting($event)"
			@dropZoneChange="handleDropZoneChange($event)"
		/>
	</Modal>
</template>

<script>
import staticAssetService from '@/services/toolbox/static-asset-service';
import Modal from '../../../components/global/Modal.vue';
import MultipleContactsImport from './MultipleContactsImport.vue';
import {
	clientReportTemplateButton,
	excelTemplateButton,
	jobAidButton,
	STATIC_ASSET_ID,
} from './MultipleContactsImportModal-constants';

export default {
	name: 'MultipleContactsImportModal',
	components: {
		Modal,
		MultipleContactsImport,
	},
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showBackCaret: false,
			waiting: false,
			modalTitle: 'Select Contact Type',
			actionBtnName: 'Next',
			altButtons: [jobAidButton],
			downloadButtons: [clientReportTemplateButton, excelTemplateButton],
			staticAssets: {
				clientReportTemplate: null,
				excelTemplate: null,
				jobAid: null,
			},
			showQuickAction: false,
		};
	},
	methods: {
		handleWaiting(data) {
			this.altButtons = [];
			this.waiting = data;
		},
		handleClick() {
			switch (this.$refs.contactimport.importState) {
				case 'select-type':
					this.$refs.contactimport.getContactList();
					break;
				case 'upload':
					this.$refs.contactimport.getFiles();
					break;
				case 'mapping':
					this.$refs.contactimport.saveMappings();
					break;
				default:
					this.handleModalClose();
					// this.showQuickAction = true;
					break;
			}
		},
		handleBackClick() {
			switch (this.$refs.contactimport.importState) {
				case 'upload':
					this.$refs.contactimport.getSelectType();
					this.$refs.importFileModal.$refs.mainActionButton.classList.remove(
						'b360-btn--disabled',
					);
					this.showBackCaret = false;
					this.showQuickAction = true;
					this.actionBtnName = 'Next';
					break;
				case 'mapping':
					this.$refs.contactimport.resetData();
					this.$refs.contactimport.getContactList();
					this.getStaticAssets();
					this.$refs.contactimport.getFiles();
					break;
				default:
					this.handleModalClose();
					this.showQuickAction = true;
					break;
			}
		},
		handleContactImportState({ importState, modalTitle }) {
			switch (importState) {
				case 'select-type':
					this.modalTitle = 'Select Contact Type';
					this.actionBtnName = 'Next';
					this.showBackCaret = false;
					break;
				case 'upload':
					this.modalTitle = modalTitle;
					this.actionBtnName = 'Upload';
					this.showBackCaret = true;
					this.showQuickAction = true;
					break;
				case 'complete':
					if (
						this.$refs.contactimport.resultCounts &&
						this.$refs.contactimport.resultCounts.SavedRecords > 0
					) {
						this.$emit('importSuccess');
						this.modalTitle = 'Upload Complete';
					} else {
						this.modalTitle = 'Upload Failed';
					}
					this.actionBtnName = 'OK';
					this.showQuickAction = false;
					this.$refs.importFileModal.$refs.cancelButton.classList.add('hidden');
					this.$refs.importFileModal.$refs.modalDialog.classList.remove(
						'mapping-width',
					);
					break;
				case 'incomplete':
					this.modalTitle = 'Please Check Back';
					this.actionBtnName = 'Close';
					this.$refs.importFileModal.$refs.cancelButton.classList.add('hidden');
					this.$refs.importFileModal.$refs.modalDialog.classList.remove(
						'mapping-width',
					);
					break;
				case 'error':
					this.modalTitle = '';
					this.actionBtnName = 'Close';
					this.$refs.importFileModal.$refs.cancelButton.classList.add('hidden');
					this.$refs.importFileModal.$refs.modalDialog.classList.remove(
						'mapping-width',
					);
					break;
				case 'mapping':
					this.modalTitle = 'Confirm All Data Fields';
					this.$refs.importFileModal.$refs.modalDialog.classList.add(
						'mapping-width',
					);
					this.showBackCaret = true;
					this.showQuickAction = false;
					this.actionBtnName = 'Save';
					break;
				default:
					this.modalTitle = 'Import Multiple Contacts';
					this.actionBtnName = 'Upload';
					this.showQuickAction = true;
					break;
			}
		},
		handleDropZoneChange(status) {
			if (this.$refs.contactimport.importState === 'upload') {
				if (status.hasFile) {
					this.$refs.importFileModal.$refs.mainActionButton.classList.remove(
						'b360-btn--disabled',
					);
				} else {
					this.$refs.importFileModal.$refs.mainActionButton.classList.add(
						'b360-btn--disabled',
					);
				}
			}
		},
		handleCalyxReportDownload() {
			const url = this.staticAssets.clientReportTemplate.filePath;
			window.open(url, '_blank');
		},
		handleExcelDownload() {
			const url = this.staticAssets.excelTemplate.filePath;
			window.open(url, '_blank');
		},
		handleJobAidDownload() {
			const url = this.staticAssets.jobAid.filePath;
			window.open(url, '_blank');
		},
		handleModalClose() {
			this.modalTitle = 'Select Contact Type';
			this.actionBtnName = 'Next';
			this.$refs.contactimport.resetData();
			this.$emit('closeModal');
		},
		async getStaticAssets() {
			try {
				const { data } = await staticAssetService.getStaticAsset();
				const enabledAltButtons = [];
				const enabledDownloadButtons = [];
				if (data.length > 0) {
					this.staticAssets.clientReportTemplate = data.find(
						(asset) =>
							asset.staticAssetID === STATIC_ASSET_ID.clientReportTemplate,
					);
					if (this.staticAssets.clientReportTemplate) {
						enabledDownloadButtons.push({
							...clientReportTemplateButton,
							disabled: false,
							class: '',
						});
					} else {
						enabledDownloadButtons.push(clientReportTemplateButton);
					}
					this.staticAssets.excelTemplate = data.find(
						(asset) => asset.staticAssetID === STATIC_ASSET_ID.excelTemplate,
					);
					if (this.staticAssets.excelTemplate) {
						enabledDownloadButtons.push({
							...excelTemplateButton,
							disabled: false,
							class: '',
						});
					} else {
						enabledDownloadButtons.push(excelTemplateButton);
					}
					this.staticAssets.jobAid = data.find(
						(asset) => asset.staticAssetID === STATIC_ASSET_ID.jobAid,
					);
					if (this.staticAssets.jobAid) {
						enabledAltButtons.push({
							...jobAidButton,
							disabled: false,
							class: 'text-button',
						});
					} else {
						enabledAltButtons.push(jobAidButton);
					}
				}
				this.altButtons =
					enabledAltButtons.length > 0 ? [...enabledAltButtons] : [];
				this.downloadButtons =
					enabledDownloadButtons.length > 0 ? [...enabledDownloadButtons] : [];
			} catch (error) {
				this.altButtons = [];
				this.downloadButtons = [];
			}
		},
	},
	computed: {
		modalWidth() {
			return {
				lg: this.modalTitle !== 'Confirm All Data Fields',
			};
		},
	},
	watch: {
		showModal(newValue) {
			if (newValue) {
				this.getStaticAssets();
				this.showQuickAction = true;
			}
		},
	},
};
</script>
